import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './ServiceFaqLists.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import noDataImg from '../../../../images/common/i_3d_no_data_doc.svg';

import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Skeleton from '@mui/material/Skeleton';

import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';


const ServiceFaqLists = () => {

    const isFirstRender = useRef(true);

    const [isLoading, setIsLoading] = useState(false);
    const [cdList, setCdList] = useState([]);
    const [qnaList, setQnaList] = useState([]);

    const faqContainerRef = useRef(null);

    const handleOnJoinMeeting = (joinUrl) => {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'OPEN_EXTERNAL_URL',
                url: joinUrl
            }));
        } else {
            window.open(joinUrl, '_blank', 'noopener,noreferrer');
        }
    };

    const [value, setValue] = useState('');

    const handleChange = (event, newValue) => {
        setValue(newValue);
        retrieveAppQnaList(newValue);
    };

    useEffect(() => {
        const fetchData = async () => {
            await getCtgrys();
            await retrieveAppQnaList('');
        };

        if (isFirstRender.current) {
            isFirstRender.current = false;
            fetchData();
            return;
        }
    }, []);

    const getCtgrys = useCallback(async () => {
        setIsLoading(true);

        const url = "/setting/retrieveAppQnaCtgrys";
        const jToken = localStorage.getItem('jToken');
        const reqOptions = {
            headers: { Authorization: jToken },
        };

        await axiosApi.post(url, {}, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setCdList([{ctgrySeCd : '', ctgrySeCdNm: '전체'}, ...res.data.result.ctgryList]);
            } else {
                alert(res.data.resultMessage);
            }
            setIsLoading(false);
        })
        .catch(err => {
            console.error("Q&A 카테고리 호출 중 오류 : ", err);
        });
    }, []);

    const retrieveAppQnaList = useCallback(async (value) => {
        const url = "/setting/retrieveAppQnaList";
        const jToken = localStorage.getItem('jToken');
        const reqOptions = {
            headers: { Authorization: jToken },
        };

        await axiosApi.post(url, {ctgrySeCd: value , bbsMasId : 1}, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setQnaList([...res.data.result.qnaList]);
            } else {
                alert(res.data.resultMessage);
            }
        })
        .catch(err => {
            console.error("Q&A 호출 중 오류 : ", err);
        });
    }, []);

    const wrapTables = (html) => {
        if (!html) return '';
        return html.replace(
            /<table([\s\S]*?)<\/table>/gi,
            `<div class="${style['table-wrapper']}"><table$1</table></div>`
        );
    };

    // 상위 컨테이너 하나에 event delegation
    useEffect(() => {
        const container = faqContainerRef.current;
        if (!container) return;

        const handleClick = (e) => {
            const anchor = e.target.closest('a');
            if (!anchor || !container.contains(anchor)) return;

            e.preventDefault();
            e.stopPropagation();

            const url = anchor.getAttribute('href');
            if (url) {
                handleOnJoinMeeting(url);
            }
        };

        container.addEventListener('click', handleClick);
        return () => container.removeEventListener('click', handleClick);
    }, [qnaList]);

    const TabPanelComp = ({cdList, qnaList}) => {

        const [expanded, setExpanded] = useState(false);

        const acHandleChange = (panel) => (event, isExpanded) => {
            setExpanded(isExpanded ? panel : false);
        };

        return (
            cdList.map((cd, index) => {
                return (
                <TabPanel key={'TabPanel' + '_' + index} value={cd.ctgrySeCd}>
                    <div className={style['tab-content']}>
                        <div className="accordion-wrap" data-type="e">
                            {
                                qnaList.map((item, qnaIdx) => {
                                    return (
                                    <Accordion key={'Accordion_' + qnaIdx} expanded={expanded === item.nttId} onChange={acHandleChange(item.nttId)}>
                                        <AccordionSummary>
                                            <div className="accordion-head">
                                                <span className='category'>{item.ctgrySeCdNm}</span>
                                                <p className="tit">
                                                    <b>Q.</b>{item.nttSj}
                                                </p>
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <div className="accordion-body">
                                                <div className='infom-box'>
                                                <p className='tit'><b>A.</b>
                                                    <span
                                                    className={style['txt-box']}
                                                    dangerouslySetInnerHTML={{ __html: wrapTables(item.nttCn) }}
                                                    />
                                                </p>
                                                </div>
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                    )
                                })
                            }
                        </div>
                    </div>
                </TabPanel>
                )
            })
        )
    }

    return (
        <>
            <HeadSub title="자주 찾는 질문" />

            <div id="sub-content" data-type="b" ref={faqContainerRef}>
                <div className='inner-wrap' data-pad="normal">

                    {cdList.length === 0 && !isLoading ? (
                        <div className={style['no-data-box']}>
                            <div className={style['img-box']}>
                                <object data={noDataImg} aria-hidden='true'></object>
                            </div>
                            <p>FAQ가 없습니다.</p>
                        </div>
                    ) : (
                        <div className={style['top-fix-bar']}>
                            <TabContext value={value}>
                                <div className="top-tab-head" data-type="b">
                                    <TabList
                                        onChange={handleChange}
                                        aria-label="lab API tabs example"
                                        variant="scrollable"
                                        scrollButtons={false}
                                        className={style['tab-lists']}
                                    >
                                        {isLoading ? (
                                            Array.from({ length: 4 }).map((_, index) => (
                                                <Tab key={`skeleton-tab-${index}`} label="" sx={{ width: 76 }} value={''} style={{backgroundColor:'#E2E6EC'}}/>
                                            ))
                                        ) : cdList.map((cd, index) => {
                                                return(
                                                <Tab key={index} label={cd.ctgrySeCdNm} value={cd.ctgrySeCd} disableRipple />
                                                )
                                            })
                                        }
                                    </TabList>
                                </div>

                                {isLoading ? (
                                    <TabPanel value={value}>
                                        <div className={style['tab-content']}>
                                            <div className="accordion-wrap" data-type="e">
                                                {Array.from({ length: 6 }).map((_, index) => (
                                                    <Accordion key={`skeleton-panel-${index}`}>
                                                        <AccordionSummary>
                                                            <div className="accordion-head">
                                                                <Skeleton variant="text" height={24} width={80}/>
                                                                <p className="tit">
                                                                    <Skeleton variant="text" height={24} width={'80%'}/>
                                                                </p>
                                                            </div>
                                                        </AccordionSummary>
                                                    </Accordion>
                                                ))}
                                            </div>
                                        </div>
                                    </TabPanel>
                                ) : <TabPanelComp cdList={cdList} qnaList={qnaList} />
                                }
                            </TabContext>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default ServiceFaqLists;